"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsGeneralSideNavControl = void 0;
const DOM_1 = require("../../../../public/js/utils/DOM");
var ControlsGeneralSideNavControl;
(function (ControlsGeneralSideNavControl) {
    class Config {
        static sideNavComponentId = 'sideNav';
        static activeClassName = 'active';
        static mobileMenuCloseTriggerElementId = 'SideNavControl-mobileMenu-hide';
    }
    ControlsGeneralSideNavControl.Config = Config;
    class Control {
        static triggerToggleMenu() {
            this.triggerMobileHide();
            this.triggerMinimizer();
        }
        static actionHideMenu() {
            DOM_1.DOM.Parser.getHtmlElement(Config.sideNavComponentId).classList.remove(Config.activeClassName);
        }
        static actionShowMenu() {
            DOM_1.DOM.Parser.getHtmlElement(Config.sideNavComponentId).classList.add(Config.activeClassName);
        }
        static triggerMobileHide() {
            const trigger = DOM_1.DOM.Parser.getHtmlElement(Config.mobileMenuCloseTriggerElementId);
            trigger.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                this.actionHideMenu();
            });
        }
        static triggerMinimizer() {
            const minimizer = DOM_1.DOM.Parser.getHtmlElement('sideNavDesktopMinimizer');
            const body = DOM_1.DOM.Parser.getBodyElement();
            minimizer.addEventListener('click', () => {
                if (DOM_1.DOM.Parser.getDataByNameFromElement('state', minimizer).toString().toLowerCase() === 'off') {
                    body.classList.add('sideNavMinimized');
                    minimizer.setAttribute('data-state', 'on');
                }
                else {
                    body.classList.remove('sideNavMinimized');
                    minimizer.setAttribute('data-state', 'off');
                }
            });
        }
    }
    ControlsGeneralSideNavControl.Control = Control;
})(ControlsGeneralSideNavControl || (exports.ControlsGeneralSideNavControl = ControlsGeneralSideNavControl = {}));
